export const METRIKA_ID = 65929705

export const ANALYTICS_EVENTS = Object.freeze([
  'route_select_taxi',
  'route_select_courier',
  'delivery_format_select',
  'fleet_click',
  'eda_click',
  'edaru_read_more_click',
  'whatsapp_click',
  'telegram_click',
  'instruction_open',
  'lena_guide_click',
  'lena_checkpoint_click',
  'lena_next_step_click',
  'payout_video_play',
  'payout_video_complete',
  'payout_help_click',
  'registration_choice',
  'registration_result',
  'delivery_form_click',
  'alex_form_click',
  'alex_contact_click',
])

export function isQaTraffic(location = typeof window === 'undefined' ? null : window.location) {
  if (!location) return false
  if (['localhost', '127.0.0.1', '[::1]'].includes(location.hostname)) return true
  const query = new URLSearchParams(location.search)
  return query.get('utm_medium') === 'codex_qa' && query.get('utm_campaign')?.startsWith('registration_') === true
}

export function loadMetrika() {
  if (typeof window === 'undefined' || window.__abgMetrikaLoaded || isQaTraffic()) return
  window.__abgMetrikaLoaded = true
  window.ym = window.ym || function metrikaQueue() {
    ;(window.ym.a = window.ym.a || []).push(arguments)
  }
  window.ym.l = Date.now()
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://mc.yandex.ru/metrika/tag.js'
  document.head.append(script)
  window.ym(METRIKA_ID, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
  })
}

export function sendGoal(eventName, payload = {}) {
  if (!ANALYTICS_EVENTS.includes(eventName)) return false
  if (!isQaTraffic() && typeof window !== 'undefined' && typeof window.ym === 'function') {
    window.ym(METRIKA_ID, 'reachGoal', eventName, payload)
  }
  return true
}

export function sendPageView(path, title) {
  if (!isQaTraffic() && typeof window !== 'undefined' && typeof window.ym === 'function') {
    window.ym(METRIKA_ID, 'hit', path, { title })
  }
}

export function installAnalyticsDelegation() {
  if (typeof document === 'undefined') return () => {}
  const handler = (event) => {
    const target = event.target.closest('[data-analytics-event]')
    if (!target) return
    sendGoal(target.dataset.analyticsEvent, {
      label: target.dataset.analyticsLabel || target.textContent.trim().slice(0, 80),
      ...(target.dataset.analyticsMomentId ? { moment_id: target.dataset.analyticsMomentId } : {}),
      page: window.location.pathname,
    })
  }
  document.addEventListener('click', handler, true)
  return () => document.removeEventListener('click', handler, true)
}
